// Copyright (c) 2025 Nebularis Holdings LLC
// Licensed to Nutrx Solutions under a non-exclusive, non-transferable license.
// See IP License Agreement for usage restrictions.
// frontend/src/components/mission-execution/shared/ExecutionModalShell.jsx

import React from "react";
import { Modal } from "../../../design-system/components";

function displayValue(value, fallback = "") {
  if (value === null || value === undefined || value === "") return fallback;
  if (
    typeof value === "string" ||
    typeof value === "number" ||
    typeof value === "boolean"
  ) {
    return String(value);
  }
  return fallback;
}

export default function ExecutionModalShell({
  open = true,
  ariaLabel,
  eyebrow,
  title,
  subtitle,
  onClose,
  children,
  maxWidth = "1180px",
  accentBorder = "rgba(96, 165, 250, 0.45)",
  zIndex = 140,
}) {
  return (
    <Modal
      open={open}
      ariaLabel={displayValue(
        ariaLabel || title,
        "Mission Execution modal"
      )}
      eyebrow={displayValue(eyebrow)}
      title={displayValue(title, "Task Execution")}
      description={displayValue(subtitle)}
      onClose={onClose}
      closeOnBackdrop={Boolean(onClose)}
      closeOnEscape={Boolean(onClose)}
      maxWidth={maxWidth}
      accentBorder={accentBorder}
      zIndex={zIndex}
      theme="inherit"
      className="execution-modal-shell"
      overlayClassName="execution-modal-overlay"
      headerClassName="execution-modal-header"
      bodyClassName="execution-modal-body"
    >
      {children}
    </Modal>
  );
}
